import { render, staticRenderFns } from "./FacebookWhite.vue?vue&type=template&id=684f1c08&scoped=true&"
import script from "./FacebookWhite.vue?vue&type=script&lang=js&"
export * from "./FacebookWhite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684f1c08",
  null
  
)

export default component.exports